'use client';

import { useSidebar } from './SidebarProvider';
import { useState, useEffect } from 'react';

export function MainContentWrapper({ children }: { children: React.ReactNode }) {
  const { isOpen } = useSidebar();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1024);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <main 
      className="main-content" 
      style={{ 
        marginLeft: (isOpen && !isMobile) ? '280px' : '0',
        paddingTop: isMobile ? '1rem' : '2rem',
        paddingBottom: isMobile ? '6rem' : '2rem',
        transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding-top 0.3s ease, padding-bottom 0.3s ease'
      }}
    >
      {children}
    </main>
  );
}
